<template>
  <div class="baggage_form">
    <b-form
      ref="form"
      class="form-wrapper"
      @submit="checkForm"
    >
      <div class="baggage-wrapper">
        <div class="trip-caption">
          <i class="fas fa-plane-departure" aria-hidden="true"></i>
          {{ $t('booking.go-flight') }}
        </div>

        <div class="baggage-items-wrapper">
          <div :class="['baggage-item-wrapper', 'bnf-bg-included']">
            <div>
              <div class="baggage-caption-wrapper">
                <div class="baggage-icon icon-handbag"></div>
                <div class="baggage-caption">{{ $t('booking.handbag-cost-included') }}</div>
              </div>
            </div>
            <div class="luggage-weight-wrapper">
              <div class="luggage-weight">{{ $t('booking.luggage-weight', {weight: maxHandbagWeight}) }}</div>
              <div class="bnf-bg-status-included" aria-label="כלול"><i class="fas fa-check-circle"></i> כלול</div>
              <div class="switch-wrapper single-row bnf-hidden-toggle">
                <b-form-checkbox v-model="hasHandbag" switch size="lg" @change="updateHandbagCheck" :disabled="true"></b-form-checkbox>
              </div>
            </div>
          </div>

          <div :class="['baggage-item-wrapper', priceInfo.trolleyPrice ? 'bnf-bg-addable' : 'bnf-bg-included']">
            <div>
              <div class="baggage-caption-wrapper">
                <div class="baggage-icon icon-trolley"></div>
                <div class="baggage-caption">{{ $t(priceInfo.trolleyPrice ? 'booking.add-trolley' : 'booking.trolley-cost-included') }}</div>
              </div>
              <div class="cost-caption" v-if="priceInfo.trolleyPrice"> {{ $t('booking.additional-trolley-cost') }} <span>{{ priceInfo.trolleyPrice + '$' }}</span></div>
            </div>
            <div class="luggage-weight-wrapper">
              <div class="luggage-weight">{{ $t('booking.luggage-weight', {weight: maxTrolleyWeight}) }}</div>
              <div class="bnf-bg-status-included" v-if="!priceInfo.trolleyPrice"><i class="fas fa-check-circle"></i> כלול</div>
              <div :class="`switch-wrapper ${priceInfo.trolleyPrice ? '' : 'single-row bnf-hidden-toggle'}`">
                <b-form-checkbox v-model="hasTrolley" switch size="lg" @change="updateTrolleyCheck" :disabled="!priceInfo.trolleyPrice"></b-form-checkbox>
              </div>
            </div>
          </div>

          <div :class="['baggage-item-wrapper', priceInfo.suitcasePrice ? 'bnf-bg-addable' : 'bnf-bg-included']">
            <div>
              <div class="baggage-caption-wrapper">
                <div class="baggage-icon icon-suitcase"></div>
                <div class="baggage-caption">{{ $t(priceInfo.suitcasePrice ? 'booking.add-suitcase' : 'booking.additional-suitcase-cost') }}</div>
              </div>
              <div class="cost-caption" v-if="priceInfo.suitcasePrice"> {{ $t('booking.additional-suitcase-cost') }} <span>{{ priceInfo.suitcasePrice + '$' }}</span></div>
            </div>
            <div class="luggage-weight-wrapper">
              <div class="luggage-weight">{{ $t('booking.luggage-weight', {weight: maxSuitcaseWeight}) }}</div>
              <div class="bnf-bg-status-included" v-if="!priceInfo.suitcasePrice"><i class="fas fa-check-circle"></i> כלול</div>
              <div :class="`switch-wrapper ${priceInfo.suitcasePrice ? '' : 'single-row bnf-hidden-toggle'}`">
                <b-form-checkbox v-model="hasSuitcase" switch size="lg" @change="updateSuitcaseCheck" :disabled="!priceInfo.suitcasePrice"></b-form-checkbox>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="baggage-wrapper">
        <div class="trip-caption">
          <i class="fas fa-plane-arrival" aria-hidden="true"></i>
          {{ $t('booking.return-flight') }}
        </div>

        <div class="baggage-items-wrapper">
          <div :class="['baggage-item-wrapper', 'bnf-bg-included']">
            <div>
              <div class="baggage-caption-wrapper">
                <div class="baggage-icon icon-handbag"></div>
                <div class="baggage-caption">{{ $t('booking.handbag-cost-included') }}</div>
              </div>
            </div>
            <div class="luggage-weight-wrapper">
              <div class="luggage-weight">{{ $t('booking.luggage-weight', {weight: maxHandbagReturnWeight}) }}</div>
              <div class="bnf-bg-status-included"><i class="fas fa-check-circle"></i> כלול</div>
              <div class="switch-wrapper single-row bnf-hidden-toggle">
                <b-form-checkbox v-model="hasHandbagReturn" switch size="lg" @change="updateHandbagReturnCheck" :disabled="true"></b-form-checkbox>
              </div>
            </div>
          </div>

          <div :class="['baggage-item-wrapper', priceInfo.trolleyReturnPrice ? 'bnf-bg-addable' : 'bnf-bg-included']">
            <div>
              <div class="baggage-caption-wrapper">
                <div class="baggage-icon icon-trolley"></div>
                <div class="baggage-caption">{{ $t(priceInfo.trolleyReturnPrice ? 'booking.add-trolley' : 'booking.trolley-cost-included') }}</div>
              </div>
              <div class="cost-caption" v-if="priceInfo.trolleyReturnPrice"> {{ $t('booking.additional-trolley-cost') }} <span>{{ priceInfo.trolleyReturnPrice + '$' }}</span></div>
            </div>
            <div class="luggage-weight-wrapper">
              <div class="luggage-weight">{{ $t('booking.luggage-weight', {weight: maxTrolleyReturnWeight}) }}</div>
              <div class="bnf-bg-status-included" v-if="!priceInfo.trolleyReturnPrice"><i class="fas fa-check-circle"></i> כלול</div>
              <div :class="`switch-wrapper ${priceInfo.trolleyReturnPrice ? '' : 'single-row bnf-hidden-toggle'}`">
                <b-form-checkbox v-model="hasTrolleyReturn" switch size="lg" @change="updateTrolleyReturnCheck" :disabled="!priceInfo.trolleyReturnPrice"></b-form-checkbox>
              </div>
            </div>
          </div>

          <div :class="['baggage-item-wrapper', priceInfo.suitcaseReturnPrice ? 'bnf-bg-addable' : 'bnf-bg-included']">
            <div>
              <div class="baggage-caption-wrapper">
                <div class="baggage-icon icon-suitcase"></div>
                <div class="baggage-caption">{{ $t(priceInfo.suitcaseReturnPrice ? 'booking.add-suitcase' : 'booking.additional-suitcase-cost') }}</div>
              </div>
              <div class="cost-caption" v-if="priceInfo.suitcaseReturnPrice"> {{ $t('booking.additional-suitcase-cost') }} <span>{{ priceInfo.suitcaseReturnPrice + '$' }}</span></div>
            </div>
            <div class="luggage-weight-wrapper">
              <div class="luggage-weight">{{ $t('booking.luggage-weight', {weight: maxSuitcaseReturnWeight}) }}</div>
              <div class="bnf-bg-status-included" v-if="!priceInfo.suitcaseReturnPrice"><i class="fas fa-check-circle"></i> כלול</div>
              <div :class="`switch-wrapper ${priceInfo.suitcaseReturnPrice ? '' : 'single-row bnf-hidden-toggle'}`">
                <b-form-checkbox v-model="hasSuitcaseReturn" switch size="lg" @change="updateSuitcaseReturnCheck" :disabled="!priceInfo.suitcaseReturnPrice"></b-form-checkbox>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { BForm, BFormCheckbox } from 'bootstrap-vue';

export default {
  props: {
    user: {
      type: Object,
      default: null,
    },
    priceInfo: {
      type: Object,
      default: null,
    }
  },
  data() {
    return {
      maxHandbagWeight: 5,
      maxTrolleyWeight: 7,
      maxSuitcaseWeight: 20,
      maxHandbagReturnWeight: 5,
      maxTrolleyReturnWeight: 7,
      maxSuitcaseReturnWeight: 20,
      hasHandbag: true,
      hasTrolley: false,
      hasSuitcase: false,
      hasHandbagReturn: true,
      hasTrolleyReturn: false,
      hasSuitcaseReturn: false,
    };
  },
  components: {
    BForm,
    BFormCheckbox,
  },
  computed: {
    ...mapGetters({
      lang: 'GET_LANGUAGE',
      device: 'GET_DEVICE',
      isAppDealPage: 'GET_IS_APP_DEAL_PAGE',
    }),
  },
  methods: {
    updateHandbagCheck(checked) {
      this.hasHandbag = checked;
      this.updateBaggageInfo();
    },
    updateTrolleyCheck(checked) {
      this.hasTrolley = checked;
      this.updateBaggageInfo();
    },
    updateSuitcaseCheck(checked) {
      this.hasSuitcase = checked;
      this.updateBaggageInfo();
    },
    updateHandbagReturnCheck(checked) {
      this.hasHandbagReturn = checked;
      this.updateBaggageInfo();
    },
    updateTrolleyReturnCheck(checked) {
      this.hasTrolleyReturn = checked;
      this.updateBaggageInfo();
    },
    updateSuitcaseReturnCheck(checked) {
      this.hasSuitcaseReturn = checked;
      this.updateBaggageInfo();
    },
    updateBaggageInfo() {
      const baggageInfo = {
        hasHandbag: this.hasHandbag,
        hasTrolley: this.hasTrolley,
        hasSuitcase: this.hasSuitcase,
        hasHandbagReturn: this.hasHandbagReturn,
        hasTrolleyReturn: this.hasTrolleyReturn,
        hasSuitcaseReturn: this.hasSuitcaseReturn,
      };

      this.$emit('updateBaggage', {
        user: this.user,
        baggageInfo
      });
    },
    checkForm(ev) {
      ev.preventDefault();
    },
  },
  created() {
    if(this.priceInfo) {
      this.maxHandbagWeight = this.priceInfo.maxHandbagWeight;
      this.maxTrolleyWeight = this.priceInfo.maxTrolleyWeight;
      this.maxSuitcaseWeight = this.priceInfo.maxSuitcaseWeight;
      this.maxHandbagReturnWeight = this.priceInfo.maxHandbagReturnWeight;
      this.maxTrolleyReturnWeight = this.priceInfo.maxTrolleyReturnWeight;
      this.maxSuitcaseReturnWeight = this.priceInfo.maxSuitcaseReturnWeight;
    }

    const baggageInfo = this.user.baggageInfo;
    if(baggageInfo) {
      this.hasHandbag = baggageInfo.hasHandbag;
      this.hasTrolley = baggageInfo.hasTrolley;
      this.hasSuitcase = baggageInfo.hasSuitcase;
      this.hasHandbagReturn = baggageInfo.hasHandbagReturn;
      this.hasTrolleyReturn = baggageInfo.hasTrolleyReturn;
      this.hasSuitcaseReturn = baggageInfo.hasSuitcaseReturn;
    }

    this.updateBaggageInfo();
  },
};
</script>

<style lang="less">
  .baggage_form{
    .custom-switch.b-custom-control-lg .custom-control-input ~ .custom-control-label::after,
    .input-group-lg .custom-switch .custom-control-input ~ .custom-control-label::after {
        transform: translateX(1rem);
    }

    .custom-switch.b-custom-control-lg .custom-control-input:checked ~ .custom-control-label::after,
    .input-group-lg .custom-switch .custom-control-input:checked ~ .custom-control-label::after {
        transform: translateX(0rem);
    }

    .custom-switch.b-custom-control-lg{
      .custom-control-label::before {
        border-color: #D8D8D8;
        background-color: #D8D8D8;
      }
      .custom-control-label::after {
        border-color: #FFFFFF;
        background-color: #FFFFFF;
      }
    }

    /* R5: switches now use brand-blue (was #FF672D orange) */
    .custom-switch .custom-control-input:checked ~ .custom-control-label::before{
      border-color: #1c7ed6;
      background-color: #1c7ed6;
    }

    /* R5: disabled+checked = "included" — softer brand-blue with reduced opacity */
    .custom-switch .custom-control-input:disabled:checked ~ .custom-control-label::before{
      border-color: #1c7ed680;
      background-color: #1c7ed680;
    }
  }
</style>

<style lang="less" scoped>
  .baggage_form {
    font-family: "ploni";
    border-radius: 16px;
    margin: 8px 0px;

    .form-wrapper{
      display: flex;
      flex-direction: column;
      gap: 20px;

      .baggage-wrapper {
        display: flex;
        flex-direction: column;
        background: #f7faff;
        border: 1px solid #e1e9f5;
        border-radius: 12px;
        padding: 14px 14px 16px;

        .trip-caption{
          display: flex;
          align-items: center;
          gap: 8px;
          font-size: 14px;
          line-height: 20px;
          font-weight: 700;
          margin-bottom: 12px;
          color: #1c4e80;
          text-transform: none;
          padding-bottom: 8px;
          border-bottom: 1px dashed #d8e3f0;
        }
        .trip-caption i {
          font-size: 13px;
          color: #1c7ed6;
          width: 22px;
          height: 22px;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          background: #eef6ff;
          border-radius: 50%;
        }

        .baggage-items-wrapper{
          display: flex;
          flex-direction: column;
          gap: 10px;

          .baggage-item-wrapper{
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            padding: 10px 12px;
            background: #ffffff;
            border: 1px solid #e3e9f1;
            border-radius: 10px;
            transition: border-color 0.2s ease, box-shadow 0.2s ease;

            /* Included items: muted, lighter, "passive" feel */
            &.bnf-bg-included {
              background: #f7faf7;
              border-color: #c8e6c9;
              padding: 8px 12px;
            }
            &.bnf-bg-included .baggage-caption {
              color: #2e7d32 !important;
              font-weight: 500 !important;
              font-size: 13px !important;
            }
            &.bnf-bg-included .baggage-icon {
              opacity: 0.7;
            }
            &.bnf-bg-included .luggage-weight {
              background: #e8f5e9 !important;
              color: #2e7d32 !important;
            }

            /* Addable items: prominent, brand-blue, action-oriented */
            &.bnf-bg-addable {
              background: linear-gradient(180deg, #ffffff 0%, #f7faff 100%);
              border-color: #cfe2ff;
              border-width: 1.5px;
              padding: 12px;
              box-shadow: 0 1px 4px rgba(28, 126, 214, 0.08);
            }
            &.bnf-bg-addable .baggage-caption {
              color: #0e436b !important;
              font-weight: 700 !important;
            }
            &.bnf-bg-addable:hover {
              border-color: #1c7ed6;
              box-shadow: 0 2px 10px rgba(28, 126, 214, 0.15);
            }

            /* Status pill — "כלול" green pill replaces toggle for included items */
            .bnf-bg-status-included {
              display: inline-flex;
              align-items: center;
              gap: 4px;
              padding: 3px 10px;
              background: #e8f5e9;
              color: #2e7d32;
              border: 1px solid #a5d6a7;
              border-radius: 999px;
              font-size: 11px;
              font-weight: 700;
              white-space: nowrap;
            }
            .bnf-bg-status-included i {
              font-size: 10px;
            }
            /* Hide the disabled toggle since the green pill replaces it */
            .bnf-hidden-toggle {
              display: none !important;
            }

            .baggage-caption-wrapper{
              display: flex;

              .baggage-icon {
                margin-left: 4px;
                width: 18px;
                height: 18px;
              }
              .icon-handbag{
                background: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 14 16' width='14' height='16'%3E%3Cpath d='M7 1.4375C6.50116 1.4375 6.02276 1.63504 5.67002 1.98667C5.31729 2.33831 5.11913 2.81522 5.11913 3.3125V5.1875H4.1787V3.3125C4.1787 2.56658 4.47594 1.85121 5.00504 1.32376C5.53413 0.796316 6.25174 0.5 7 0.5C7.74826 0.5 8.46587 0.796316 8.99496 1.32376C9.52406 1.85121 9.8213 2.56658 9.8213 3.3125V5.1875H8.88087V3.3125C8.88087 2.81522 8.68271 2.33831 8.32998 1.98667C7.97724 1.63504 7.49884 1.4375 7 1.4375ZM4.1787 5.1875H2.63638C2.29865 5.18757 1.97215 5.30844 1.71622 5.52813C1.4603 5.74782 1.29193 6.05175 1.24172 6.38469L0.275892 12.8094C0.225849 13.1427 0.248525 13.4829 0.342372 13.8068C0.436218 14.1306 0.599028 14.4304 0.819694 14.6858C1.04036 14.9412 1.31369 15.1462 1.62104 15.2867C1.92839 15.4272 2.26252 15.4999 2.60065 15.5H11.3984C11.7366 15.5001 12.0709 15.4274 12.3783 15.287C12.6858 15.1465 12.9592 14.9416 13.18 14.6862C13.4008 14.4308 13.5637 14.1309 13.6576 13.807C13.7515 13.4831 13.7742 13.1428 13.7241 12.8094L12.7573 6.38469C12.7072 6.05191 12.5389 5.7481 12.2832 5.52843C12.0275 5.30876 11.7012 5.1878 11.3636 5.1875H9.8213V6.59375C9.8213 6.71807 9.77176 6.8373 9.68358 6.92521C9.5954 7.01311 9.4758 7.0625 9.35109 7.0625C9.22638 7.0625 9.10678 7.01311 9.01859 6.92521C8.93041 6.8373 8.88087 6.71807 8.88087 6.59375V5.1875H5.11913V6.59375C5.11913 6.71807 5.06959 6.8373 4.98141 6.92521C4.89322 7.01311 4.77362 7.0625 4.64891 7.0625C4.5242 7.0625 4.4046 7.01311 4.31642 6.92521C4.22824 6.8373 4.1787 6.71807 4.1787 6.59375V5.1875Z' fill='black'/%3E%3C/svg%3E") no-repeat center;
              }
              .icon-trolley{
                background: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 11 17' width='11' height='17'%3E%3Cpath d='M11 4.74997C10.9994 4.29549 10.7977 3.85978 10.439 3.53841C10.0804 3.21705 9.59418 3.03627 9.08701 3.03574H8.2101V1.28558H8.2899C8.48014 1.28558 8.66259 1.21786 8.79712 1.09731C8.93164 0.976766 9.00722 0.81327 9.00722 0.642791C9.00722 0.472312 8.93164 0.308816 8.79712 0.188269C8.66259 0.0677224 8.48014 2.54033e-09 8.2899 0H2.7101C2.6159 -1.25784e-09 2.52263 0.0166263 2.4356 0.0489296C2.34857 0.0812328 2.26949 0.12858 2.20288 0.188269C2.13627 0.247958 2.08343 0.318819 2.04739 0.396806C2.01134 0.474793 1.99278 0.558379 1.99278 0.642791C1.99278 0.727204 2.01134 0.81079 2.04739 0.888777C2.08343 0.966764 2.13627 1.03762 2.20288 1.09731C2.26949 1.157 2.34857 1.20435 2.4356 1.23665C2.52263 1.26896 2.6159 1.28558 2.7101 1.28558H2.7899V3.03574H1.91299C1.40582 3.03627 0.919583 3.21705 0.560956 3.53841C0.202329 3.85978 0.000591804 4.29549 0 4.74997V12.6072C0.000998539 12.8565 0.0630506 13.1025 0.181776 13.328C0.300502 13.5535 0.473007 13.7528 0.687115 13.912C0.373929 14.2472 0.201363 14.67 0.199278 15.1072C0.199278 15.6092 0.42182 16.0906 0.817947 16.4456C1.21407 16.8006 1.75134 17 2.31155 17C2.87176 17 3.40902 16.8006 3.80515 16.4456C4.20128 16.0906 4.42382 15.6092 4.42382 15.1072C4.42266 14.8356 4.35567 14.5675 4.22748 14.3214H6.77256C6.64437 14.5675 6.57737 14.8356 6.57622 15.1072C6.57622 15.6092 6.79876 16.0906 7.19489 16.4456C7.59101 16.8006 8.12828 17 8.68849 17C9.24869 17 9.78596 16.8006 10.1821 16.4456C10.5782 16.0906 10.8008 15.6092 10.8008 15.1072C10.7987 14.67 10.6261 14.2472 10.3129 13.912C10.527 13.7528 10.6995 13.5535 10.8182 13.328C10.9369 13.1025 10.999 12.8565 11 12.6072V4.74997ZM4.22454 1.28558H6.77546V3.03574H4.22454V1.28558ZM4.38404 11.5357C4.38358 11.7059 4.3078 11.869 4.17333 11.9893C4.03886 12.1095 3.85666 12.177 3.66672 12.177C3.47677 12.177 3.29458 12.1095 3.1601 11.9893C3.02563 11.869 2.94985 11.7059 2.94939 11.5357V5.82141C2.94985 5.6512 3.02563 5.4881 3.1601 5.36789C3.29458 5.24768 3.47677 5.18017 3.66672 5.18017C3.85666 5.18017 4.03886 5.24768 4.17333 5.36789C4.3078 5.4881 4.38358 5.6512 4.38404 5.82141V11.5357ZM8.05069 11.5357C8.05023 11.7059 7.97446 11.869 7.83998 11.9893C7.70551 12.1095 7.52332 12.177 7.33337 12.177C7.14342 12.177 6.96123 12.1095 6.82676 11.9893C6.69228 11.869 6.61651 11.7059 6.61605 11.5357V5.82141C6.61651 5.6512 6.69228 5.4881 6.82676 5.36789C6.96123 5.24768 7.14342 5.18017 7.33337 5.18017C7.52332 5.18017 7.70551 5.24768 7.83998 5.36789C7.97446 5.4881 8.05023 5.6512 8.05069 5.82141V11.5357Z' fill='black'/%3E%3C/svg%3E") no-repeat center;
              }
              .icon-suitcase{
                background: url("data:image/svg+xml,%3Csvg width='16' height='15' viewBox='0 0 16 15' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M0.5 4.75C0.5 3.64543 1.39543 2.75 2.5 2.75H2.75V14.75H2.5C1.39543 14.75 0.5 13.8546 0.5 12.75V4.75ZM4.25 14.75H12.4994V2.75H4.25V14.75ZM13.9994 2.81285C13.8398 2.77182 13.6724 2.75 13.5 2.75H13.9994V2.81285ZM13.9994 14.6872V2.81285C14.8623 3.03466 15.5 3.81786 15.5 4.75V12.75C15.5 13.6821 14.8623 14.4653 13.9994 14.6872ZM13.9994 14.6872V14.75H13.5C13.6724 14.75 13.8398 14.7282 13.9994 14.6872Z' fill='black'/%3E%3Cpath d='M5 2.75V1.67857C5 1.44188 5.41328 1.25 5.92308 1.25H10.0769C10.5867 1.25 11 1.44188 11 1.67857V2.75' stroke='black' stroke-width='1.5'/%3E%3C/svg%3E") no-repeat center;
              }
              .baggage-caption{
                font-size: 14px;
                line-height: 1.35;
                font-weight: 600;
                color: #0e436b;
              }
            }
            .cost-caption{
              display: inline-flex;
              align-items: center;
              gap: 6px;
              font-size: 12px;
              line-height: 1.3;
              font-weight: 500;
              color: #475569;
              margin: 6px 28px 0 0;
              padding: 3px 10px 3px 8px;
              background: #eef6ff;
              border: 1px solid #cfe2ff;
              border-radius: 999px;
              width: fit-content;

              span{
                font-weight: 700;
                color: #0e436b;
                font-size: 13px;
              }
            }

            .luggage-weight-wrapper{
              display: flex;
              align-items: center;
              gap: 10px;

              .luggage-weight{
                margin: 0;
                font-size: 12px;
                color: #6c7a8c;
                font-weight: 500;
                background: #f1f5f9;
                padding: 3px 10px;
                border-radius: 999px;
                white-space: nowrap;
              }
              .switch-wrapper{
                margin-top: 0;
              }
              .switch-wrapper.single-row{
                margin-top: 0;
              }
            }
          }
        }
      }
    }
  }

  @media (max-width: 479px) {
  }
</style>
